import { useState } from "react";
import { BarChart3, Inbox, CalendarCheck, Users, Tags, FileSignature, Receipt, Award, Newspaper, Settings, ExternalLink } from "lucide-react";
import { useCommerceApi } from "./shared";
import { CommerceOverview } from "./CommerceOverview";
import { CommerceLeads } from "./CommerceLeads";
import { CommerceBookings } from "./CommerceBookings";
import { CommerceClients } from "./CommerceClients";
import { CommerceServicesPricing, CommerceCaseStudies } from "./CommerceContent";
import { CommerceProposals } from "./CommerceProposals";
import { CommerceInvoices } from "./CommerceInvoices";
import { CommerceBlog } from "./CommerceBlog";
import { CommerceSettings } from "./CommerceSettings";

const SECTIONS = [
  { id: "overview", label: "Overview", icon: BarChart3, C: CommerceOverview },
  { id: "leads", label: "Leads & enquiries", icon: Inbox, C: CommerceLeads },
  { id: "bookings", label: "Consultations", icon: CalendarCheck, C: CommerceBookings },
  { id: "clients", label: "Customers & projects", icon: Users, C: CommerceClients },
  { id: "services", label: "Services & pricing", icon: Tags, C: CommerceServicesPricing },
  { id: "proposals", label: "Proposals & agreements", icon: FileSignature, C: CommerceProposals },
  { id: "invoices", label: "Invoices & payments", icon: Receipt, C: CommerceInvoices },
  { id: "case-studies", label: "Case studies", icon: Award, C: CommerceCaseStudies },
  { id: "blog", label: "Blog & SEO", icon: Newspaper, C: CommerceBlog },
  { id: "settings", label: "Settings", icon: Settings, C: CommerceSettings },
];

export const CommerceManagement = ({ token }) => {
  const [section, setSection] = useState("overview");
  const call = useCommerceApi(token);
  const { C } = SECTIONS.find(s => s.id === section);
  return (
    <div className="space-y-6" data-testid="commerce-management">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold tracking-widest text-indigo-600">VEYRONIX COMMERCE DIVISION</p>
          <h2 className="font-heading text-2xl font-bold text-slate-900">Commerce Management</h2>
        </div>
        <a href="/commerce" target="_blank" rel="noreferrer" className="text-sm text-indigo-600 hover:text-indigo-800 inline-flex items-center gap-1" data-testid="commerce-view-site">
          View public Commerce site <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      <nav className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1" data-testid="commerce-subnav">
        {SECTIONS.map(s => (
          <button key={s.id} onClick={() => setSection(s.id)} data-testid={`commerce-section-${s.id}`}
            className={`shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-colors ${section === s.id ? "bg-indigo-600 text-white" : "bg-white border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-300"}`}>
            <s.icon className="h-4 w-4" />{s.label}
          </button>
        ))}
      </nav>
      <C key={section} call={call} token={token} />
    </div>
  );
};
